module.exports = __webpack_public_path__ + "img/zxsign2.809f153a.png";